export default __webpack_public_path__ + "static/media/openbook.3051e78f.svg";